import axios from 'axios'
import jwtDecode from 'jwt-decode'
import { toast } from 'react-toastify'

axios.defaults.baseURL = process.env.REACT_APP_GATEWAY_BASE_URL

axios.interceptors.request.use(
  (config) => {
    const isLoginRequest = config.url?.includes('/login') || config.url?.includes('login')
    const isAbsoluteUrl = config.url?.startsWith('http')
    const actualFullURL = isAbsoluteUrl ? config.url : `${config.baseURL || ''}${config.url}`

    console.log('🚀 [AXIOS-REQUEST] Iniciando requisição:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      fullURL: actualFullURL,
      isFormData: config.data instanceof FormData,
      isLoginRequest
    })

    if (isLoginRequest) {
      const loginFullURL = config.url?.startsWith('http') ? config.url : `${config.baseURL || ''}${config.url}`

      console.log('🚀 [AXIOS-INTERCEPTOR-LOGIN] Requisição de LOGIN sendo enviada:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL,
        fullURL: loginFullURL,
        hasData: !!config.data,
        data: config.data ? {
          hasEmail: !!config.data.email,
          hasPassword: !!config.data.password,
          email: config.data.email
        } : null,
        timestamp: new Date().toISOString()
      })
    }

    const token = localStorage.getItem('token')
    let decodedToken: any = null

    console.log('🔑 [AXIOS-REQUEST] Token status:', {
      hasToken: !!token,
      tokenLength: token?.length,
      tokenPreview: token ? `${token.substring(0, 30)}...` : 'sem token'
    });

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      console.log('✅ [AXIOS-REQUEST] Authorization header adicionado');

      try {
        decodedToken = jwtDecode(token)
        console.log('🔍 [AXIOS-REQUEST] Token decodificado:', {
          sub: decodedToken.sub,
          tenantId: decodedToken.tenantId,
          exp: decodedToken.exp,
          iat: decodedToken.iat,
          isExpired: decodedToken.exp < Date.now() / 1000
        });

        if (decodedToken.tenantId) {
          console.log('✅ [AXIOS-REQUEST] TenantId presente no token (não será enviado por header):', decodedToken.tenantId);
        }
      } catch (error) {
        console.error('❌ [AXIOS-REQUEST] Erro ao decodificar token:', error)
      }
    } else {
      console.warn('⚠️ [AXIOS-REQUEST] Nenhum token encontrado no localStorage')
    }

    if (config.data instanceof FormData) {
      console.log('📦 [AXIOS-REQUEST] FormData detectado:', {
        url: config.url,
        method: config.method,
        hasAuth: !!config.headers.Authorization,
        tenantId: undefined,
        formDataKeys: Array.from(config.data.keys()),
        allHeaders: Object.keys(config.headers),
        formDataSize: `${(new Blob([...config.data.values()]).size / 1024).toFixed(2)}KB`
      })

      const keys = Array.from(config.data.keys());
      console.log(`🔍 [AXIOS-DEBUG] FormData - Total de campos: ${keys.length}`);
      console.log(`🔍 [AXIOS-DEBUG] FormData - Primeiros 15 campos:`, keys.slice(0, 15));
      if (keys.length > 15) {
        console.log(`🔍 [AXIOS-DEBUG] FormData - E mais ${keys.length - 15} campos...`);
      }

      let emptyFieldsCount = 0;
      const emptyFields: string[] = [];
      keys.forEach(key => {
        const value = config.data.get(key);
        if (!value || value === '' || value === 'undefined' || value === 'null') {
          emptyFieldsCount++;
          if (emptyFields.length < 10) {
            emptyFields.push(key);
          }
        }
      });

      console.log(`🚿 [AXIOS-DEBUG] FormData - Campos vazios: ${emptyFieldsCount} de ${keys.length}`, emptyFields);

      if (token && !config.headers.Authorization) {
        console.log('⚠️ [AXIOS-REQUEST] FormData sem Authorization, aplicando token...')
        config.headers.Authorization = `Bearer ${token}`

        try {
          const decodedToken: any = jwtDecode(token)
        } catch (error) {
          console.error('❌ [AXIOS-REQUEST] Erro ao decodificar token para FormData:', error)
        }
      }
    }

    const finalURL = config.url?.startsWith('http') ? config.url : `${config.baseURL || ''}${config.url}`

    console.log('🚀 [AXIOS-REQUEST] Request final configurado:', {
      url: finalURL,
      method: config.method,
      hasAuthorization: !!config.headers.Authorization,
      tenantId: decodedToken?.tenantId,
      contentType: config.headers['content-type'] || config.headers['Content-Type'],
      headersCount: Object.keys(config.headers).length,
      isFormData: config.data instanceof FormData,
      totalFields: config.data instanceof FormData ? Array.from(config.data.keys()).length : 'N/A',
      params: config.params
    });
    console.log('📤 [AXIOS-REQUEST] Enviando requisição...');

    return config
  },
  (error) => {
    console.error('❌ [AXIOS-REQUEST] Erro no interceptor REQUEST:', {
      message: error.message,
      config: error.config ? {
        url: error.config.url,
        method: error.config.method,
        hasAuth: !!error.config.headers?.Authorization
      } : 'sem config'
    });
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    console.log('✅ [AXIOS-RESPONSE] Resposta recebida:', {
      status: response.status,
      statusText: response.statusText,
      url: response.config.url,
      method: response.config.method,
      hasData: !!response.data,
      dataType: typeof response.data,
      headers: {
        contentType: response.headers['content-type'],
        contentLength: response.headers['content-length']
      },
      isLoginResponse: response.config.url?.includes('/login') || response.config.url?.includes('login')
    })

    const isLoginResponse = response.config.url?.includes('/login') || response.config.url?.includes('login')

    if (isLoginResponse) {
      console.log('✅ [AXIOS-INTERCEPTOR-LOGIN] Resposta de LOGIN recebida:', {
        status: response.status,
        statusText: response.statusText,
        url: response.config.url,
        method: response.config.method,
        hasData: !!response.data,
        dataKeys: response.data ? Object.keys(response.data) : [],
        hasAccessToken: !!response.data?.access_token,
        tokenLength: response.data?.access_token?.length,
        tokenPreview: response.data?.access_token ? `${response.data.access_token.substring(0, 50)}...` : null,
        headers: {
          contentType: response.headers['content-type'],
          contentLength: response.headers['content-length'],
          setCookie: response.headers['set-cookie'] ? 'Presente' : 'Ausente'
        },
        timestamp: new Date().toISOString()
      })
    };
    return response
  },
  (error) => {
    if (axios.isCancel(error)) {
      console.log('🚫 [AXIOS-RESPONSE] Requisição cancelada pelo cliente:', error.message);
      return Promise.reject(error)
    }
    console.error('❌ [AXIOS-RESPONSE] Erro na resposta:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      method: error.config?.method,
      message: error.message,
      responseData: error.response?.data,
      hasFormData: error.config?.data instanceof FormData,
      requestHeaders: {
        hasAuth: !!error.config?.headers?.Authorization,
        contentType: error.config?.headers?.['content-type']
      }
    });
    console.error('❌ [AXIOS-RESPONSE] DETALHES DO ERRO (STRING):', JSON.stringify(error.response?.data || {}));

    try {
      const respData = error.response?.data
      if (respData && typeof respData.text === 'function') {
        respData.text().then((text: string) => {
          console.error('❌ [AXIOS-RESPONSE] Error body text:', text)
        }).catch((e: any) => {
          console.error('❌ [AXIOS-RESPONSE] Falha ao ler body do erro:', e)
        })
      }
    } catch (e) {
      console.error('❌ [AXIOS-RESPONSE] Exceção ao tentar ler body do erro:', e)
    }

    if (error.response?.status === 401) {
      const isInSaveProcess = error.config?.data instanceof FormData
      const isMaintenanceMode = error.response?.data?.message === 'MAINTENANCE_MODE'

      if (isMaintenanceMode) {
        localStorage.removeItem('token')
        window.location.href = '/login?maintenance=true'
        return Promise.reject(error)
      }

      console.warn('🚫 [AXIOS-RESPONSE] Erro 401 - Unauthorized:', {
        isInSaveProcess,
        currentPath: window.location.pathname
      });

      if (!isInSaveProcess) {
        try {
          const token = localStorage.getItem('token')
          if (!token) {
            localStorage.removeItem('token')
            window.location.href = '/'
          } else {
            const decoded: any = jwtDecode(token)
            const isExpired = decoded.exp < Date.now() / 1000
            if (isExpired) {
              localStorage.removeItem('token')
              window.location.href = '/'
            } else {
              toast.warn('Operação não autorizada. Você não possui permissão para esta ação.')
            }
          }
        } catch (e) {
          localStorage.removeItem('token')
          window.location.href = '/'
        }
      }
    }

    if (error.response?.status === 503) {
      const isMaintenanceMode = error.response?.data?.error === 'MAINTENANCE_MODE'
      if (isMaintenanceMode) {
        localStorage.removeItem('token')
        window.location.href = '/login?maintenance=true'
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)

export default axios
